import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrows-exchange', 'ArrowsExchange', [["path",{"d":"M7 10h14l-4 -4"}],["path",{"d":"M17 14h-14l4 4"}]]);